import { Component } from '@angular/core';

@Component({
    selector: 'app-reports-menu',
    templateUrl: './reports-menu.component.html',
    styleUrl: './reports-menu.component.css',
})
export class ReportsMenuComponent {
    navigationGroup: any = [
        {
            label: 'Financial Report',
            icon: 'money-bill',
            description:
                'View and analyze financial data through structured reports',
            children: [
                {
                    label: 'Monthly Billing',
                    icon: 'ticket',
                    link: 'report/monthlybilling',
                },
                {
                    label: 'Payments',
                    icon: 'money-bill',
                    link: 'report/payments',
                },
                {
                    label: 'Payment Plan Forecast',
                    icon: 'fast-forward',
                    link: 'report/payment-plan-forecast',
                },
            ],
        },
        {
            label: 'Communication Reports',
            icon: 'comments',
            description:
                'View and analyze communication activities across channels',
            children: [
                {
                    label: 'Notification Metrics',
                    icon: 'megaphone',
                    link: 'report/notifications',
                },
                {
                    label: 'Campaign Trackers',
                    link: 'campaign-trackers',
                    icon: 'map',
                },
                {
                    label: 'SMS & Email Errors',
                    link: 'reports/sms-email-errors',
                    icon: 'exclamation-circle',
                },
            ],
        },
        {
            label: 'Audit Reports',
            icon: 'check-circle',
            description:
                'View and analyze system audit logs to track user actions',
            children: [
                {
                    label: 'Http Gateway Requests',
                    link: 'report/gateway-requests',
                    icon: 'cloud',
                },
                {
                    label: 'QFund Transactions',
                    link: 'report/qfund-transactions',
                    icon: 'money-bill',
                },
            ],
        },
        {
            label: 'Dashboard Graphs',
            icon: 'chart-bar',
            description:
                'Access graphical insights to monitor performance and data patterns',
            children: [
                {
                    label: 'Reporting Dashboard',
                    link: 'dashboard',
                    icon: 'chart-pie',
                },
                {
                    label: 'Trend Analysis',
                    link: 'trend-analysis',
                    icon: 'chart-line',
                },
            ],
        },
    ];
}
